import { render, staticRenderFns } from "./LoginDealCertificates.vue?vue&type=template&id=ee49ce46&scoped=true&"
import script from "./LoginDealCertificates.vue?vue&type=script&lang=js&"
export * from "./LoginDealCertificates.vue?vue&type=script&lang=js&"
import style0 from "./LoginDealCertificates.vue?vue&type=style&index=0&id=ee49ce46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee49ce46",
  null
  
)

export default component.exports